app.service('articlesListView', function(articlesSidebar, loading, modal) {
	var $category, $list, $search, $order;

	function setElements(){
		$list = $('#news-listing');
		$category = $('#filter-categories input:checkbox');
		$order = $('#filter-order input');
		$search = $('#serach-news-input');
	}
	function setEvents(){
		$category.click(function(){
			newsRedirect();
		});
		$order.change(function(){
			newsRedirect();
		});
		$list.on('click', '.js-more-news', function(){
			newsRedirect($(this).data('page')/1);
		});
		$('#serach-news-button').click(function(){
			newsRedirect();
		});
		$search.keyup(function(e) {
			if (e.keyCode == 13){
				newsRedirect();
			}
		});
	}
	function init() {
		setElements();
		setEvents();
		articlesSidebar.init();
	}
	function newsRedirect(page=1){
		var url = 'news-single-list-page.bhtml';
		var data = {
			pageNumber: page || 1
		};
		var $selectedCategory = $category.filter(':checked');
		var category = [];
		$selectedCategory.each(function(){
			var value =  $(this).val();
			if(value && value !== 'all'){
				category.push(value);
			}
		});
		var search = $search.val().trim();
		var order = $order.val().trim();

		if(category.length){
			data.categoriesIds=category;
		}
		if(order.length){
			data.order=order;
		}
		if(search.length){
			data.search=search;
		}

		loading.start();
		$.ajax({
			url:'/news-single-list-page.bhtml',
			data: data,
			success:function(html){
				loading.stop();
				$list.find('.news-buttons').remove();
				if(page>1){
					$list.append(html);
				}else{
					$list.html(html);
				}
				if($list.find('.news-empty').length){
					$list.html(html);
				}
			},
			error:function(){
				loading.stop();
				modal.alert('Błąd pobierania artykułów')
			}
		});
	}

	return {
		init: init
	};
});
